export default __webpack_public_path__ + "static/media/logo-or.dda6ce7f.png";